// tslint:disable:no-any no-unsafe-any no-reserved-keywords
import * as tslib_1 from "tslib";
let $$Vue;
/**
 * Localization plugin for Vue.js 2+
 */
export default class VueLocale {
    /**
     *
     */
    constructor(options) {
        // validate
        if (!options || !options.dicts || typeof options.dicts !== 'object') {
            throw error('invalid options for create VueLocale instance.');
        }
        this.cache = options.cache === undefined ? true : options.cache;
        this._dicts = options.dicts;
        this._vm = new $$Vue({
            data() {
                return {
                    $$loading: false,
                    $$language: '',
                    $$dict: {},
                };
            },
        });
    }
    // tslint:enable:variable-name
    get loading() {
        return this._vm._data.$$loading;
    }
    get language() {
        return this._vm._data.$$language;
    }
    set language(value) {
        // tslint:disable-next-line:no-floating-promises
        this.selectLanguage(value);
    }
    get dict() {
        return this._vm._data.$$dict;
    }
    set dict(value) {
        throw error('use VueLocale.selectLanguage() or reassign VueLocale.language to explicit replace VueLocale.dict.');
    }
    /**
     * select
     */
    selectLanguage(language) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.loading) {
                return;
            }
            this._vm._data.$$loading = true;
            let probable = language;
            let dict = this._dicts[probable];
            if (!dict) {
                const probables = [language.replace(/-/g, ''), language.split('-')[0]];
                const languages = Object.keys(this._dicts);
                probable = probables.find(p => languages.includes(p));
                if (probable) {
                    dict = this._dicts[probable];
                }
            }
            if (!dict) {
                const dicts = Object.keys(this._dicts).join(', ');
                this._vm._data.$$loading = false;
                throw error(`dict for language ${language} not found, installed dicts: ${dicts}.`);
            }
            else {
                if (typeof dict === 'function') {
                    let raw = yield dict();
                    if ('default' in raw && typeof raw.default === 'object') {
                        raw = raw.default;
                    }
                    if (this.cache && probable) {
                        this._dicts[probable] = raw;
                    }
                    this._vm._data.$$dict = Object.assign({}, raw);
                }
                else {
                    this._vm._data.$$dict = Object.assign({}, dict);
                }
                this._vm._data.$$language = probable;
                this._vm._data.$$loading = false;
            }
        });
    }
}
VueLocale.install = $Vue => {
    if ($$Vue && $$Vue === $Vue) {
        return;
    }
    $$Vue = $Vue;
    $Vue.mixin({
        beforeCreate() {
            if (this.$options.locale) {
                this.$locale = this.$options.locale;
            }
            else if (this.$options.parent && this.$options.parent.$locale) {
                this.$locale = this.$options.parent.$locale;
            }
        },
    });
};
function error(message) {
    return new Error(`[vue-locale] ${message}`);
}
//# sourceMappingURL=index.js.map